export default "__VITE_ASSET__jM571O8$__"